export const SystemProductType = {
  CHATBOT: "chatbot",
  VOICEBOT: "voicebot",
  CENTERFLOW: "centerflow",
  CERTIFICATE: "certificate",
  VOICEBOT_VOX: "voicebot-vox",
  VOICEBOT_VOX_IPCC: "voicebot-vox-ipcc",
};

export const SystemProductTypeLabel = {
  [SystemProductType.CHATBOT]: "챗봇",
  [SystemProductType.VOICEBOT]: "음성봇",
  [SystemProductType.CENTERFLOW]: "센터플로우",
  [SystemProductType.CERTIFICATE]: "CRM메세지",
  [SystemProductType.VOICEBOT_VOX]: "음성봇(Vox ai AICC)",
  [SystemProductType.VOICEBOT_VOX_IPCC]: "음성봇(Vox ai IPCC)",
};

export const SystemProductTypeIcon = {
  [SystemProductType.CHATBOT]: "fa-comments",
  [SystemProductType.VOICEBOT]: "fa-microphone",
  [SystemProductType.CENTERFLOW]: "fa-chart-network",
  [SystemProductType.CERTIFICATE]: "fa-file-certificate",
  [SystemProductType.VOICEBOT_VOX]: "fa-microphone",
  [SystemProductType.VOICEBOT_VOX_IPCC]: "fa-microphone",
};

export const UsageFeeTypeLabel = {
  monthly: "월간",
  yearly: "연간",
  oneTime: "일회성",
  perTransaction: "건당",
};
